import axiosInstance from '../lib/axios';

export const notificationService = {
  getNotifications: (params: {
    page?: number;
    limit?: number;
    is_read?: boolean;
  }) => {
    const { is_read, ...rest } = params;
    const query: Record<string, unknown> = { ...rest };
    if (is_read !== undefined) query.read = is_read;
    return axiosInstance.get('/notifications', { params: query });
  },

  getUnreadCount: () =>
    axiosInstance.get('/notifications/count'),

  markRead: (notificationId: string) =>
    axiosInstance.patch(`/notifications/${notificationId}/read`),

  markAllRead: () =>
    axiosInstance.patch('/notifications/read-all'),
};

export default notificationService;
